import React from "react";
import PropTypes from "prop-types";

import classNames from "classnames";
import styles from "./Icons.module.scss";

export const Close = ({ className, color }) => {

    const cx = classNames.bind(styles);

    const classes = cx(
        "wrapper",
        className
    );

    return (
        <svg classNAme={styles.classes}xmlns="http://www.w3.org/2000/svg" width="25.691" height="25.691" viewBox="0 0 25.691 25.691">
            <path fill={color} d="M16.221,3.375A12.846,12.846,0,1,0,29.066,16.221,12.8,12.8,0,0,0,16.221,3.375Zm6.423,17.47-1.8,1.8-4.625-4.625L11.6,22.643l-1.8-1.8,4.625-4.625L9.8,11.6l1.8-1.8,4.625,4.624L20.845,9.8l1.8,1.8-4.625,4.625Z" transform="translate(-3.375 -3.375)" />
        </svg>
    );
};
    
Close.propTypes = {
    className: PropTypes.string,
    color: PropTypes.string
};

Close.defaultProps = {
    color: "#fff"
};